import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientStatisticsComponent } from './client-statistics.component';
import { IonicModule } from '@ionic/angular';
import { TranslationModule } from '@app/app-translation.module';
import { ClientsOnAgeCategoriesStatisticComponentModule } from '../clients-on-age-categories-statistic-component/clients-on-age-categories-statistic.component.module';
import { ClientsOnGendersStatisticComponentModule } from '../clients-on-genders-statistic-component/clients-on-genders-statistic.component.module';
import { ClientsOnOriginsStatisticComponentModule } from '../clients-on-origins-statistic-component/clients-on-origins-statistic.component.module';
import { ClientsOnTargetAudiencesStatisticComponentModule } from '../clients-on-target-audiences-statistic-component/clients-on-target-audiences-statistic.component.module';
import { ClientsOnZipcodesStatisticComponentModule } from '../clients-on-zipcodes-statistic-component/clients-on-zipcodes-statistic.component.module';
import { ClientsCountStatisticComponentModule } from '../clients-count-statistic-component/clients-count-statistic.component.module';
import { ClientsOnDevicesStatisticComponentModule } from '../clients-on-devices-statistic-component/clients-on-devices-statistic.component.module';
import { ClientsOnAttendancesCountStatisticComponentModule } from '../clients-on-attendances-count-statistic-component/clients-on-attendances-count-statistic.component.module';
import { StatisticFilterComponentModule } from '@internal-components/statistic-components/statistic-filter-component/statistic-filter.component.module';

@NgModule({
	declarations: [ClientStatisticsComponent],
	exports: [ClientStatisticsComponent],
	imports: [
		CommonModule,
		IonicModule,
		TranslationModule,
		StatisticFilterComponentModule,
		ClientsCountStatisticComponentModule,
		ClientsOnZipcodesStatisticComponentModule,
		ClientsOnTargetAudiencesStatisticComponentModule,
		ClientsOnGendersStatisticComponentModule,
		ClientsOnOriginsStatisticComponentModule,
		ClientsOnAgeCategoriesStatisticComponentModule,
		ClientsOnDevicesStatisticComponentModule,
		ClientsOnAttendancesCountStatisticComponentModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClientStatisticsComponentModule {}
